/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Discard Filters Icon component.
 */
export const DiscardFiltersIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M3.45771 1.68999C3.20718 1.36014 2.73668 1.29583 2.40682 1.54637C2.07696 1.7969 2.01266 2.2674 2.26319 2.59726L16.5464 21.4027C16.7969 21.7326 17.2674 21.7969 17.5973 21.5464C17.9271 21.2958 17.9914 20.8253 17.7409 20.4955L3.45771 1.68999ZM15.9999 15.7372L14.4999 13.7684V12.3431C14.4999 11.7872 14.6852 11.2471 15.0266 10.8083L19.933 4.5H7.43826L6.2954 3H20.9553C21.7874 3 22.2555 3.95708 21.7446 4.61394L16.2106 11.7292C16.0741 11.9047 15.9999 12.1207 15.9999 12.3431V15.7372ZM9.99993 19.865V12.8123L11.4999 14.7811V18.7974L13.3716 17.2377L14.2816 18.432L11.6401 20.6332C10.9888 21.176 9.99993 20.7128 9.99993 19.865Z" fill={iconColor}/>
    </svg>
  );
};

export default DiscardFiltersIcon;
